
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/transfers",
      function () {
        return require("private-next-pages/concierge/transfers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/transfers"])
      });
    }
  